import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  const articleListSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '爱液官网健康百科 - 润滑液使用指南与私密健康科普',
    description: '爱液官网健康百科，提供专业润滑液选购指南、使用方法、成分解析及女性私密健康护理知识。科学私护，从了解开始。',
    url: 'https://www.aiye-official.com/articles'
  };

  return (
    <>
      <SEOHead
        title="健康百科 - 爱液官网润滑液使用指南与私密健康科普"
        description="爱液官网健康百科为您提供专业润滑液选购指南、正确使用方法、成分安全解析及女性私密健康护理知识。科学私护，从了解开始。"
        keywords="爱液官网使用方法,润滑液选购指南,私密健康护理,润滑液成分解析,女性健康科普"
        canonicalUrl="/articles"
        structuredData={articleListSchema}
      />

      <Navbar />

      <main className="pt-16 md:pt-18">
        <Breadcrumb
          items={[
            { label: '首页', to: '/' },
            { label: '健康百科' }
          ]}
        />

        {/* Page Header */}
        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="w-full px-4 md:px-6 text-center">
            <h1 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
              健康百科
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              专业私密健康知识分享，从选购到使用，从成分到护理 —— 科学私护，从这里开始
            </p>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}